<template>
  <v-dialog :value="value" max-width="720" @input="$emit('input', $event)">
    <v-card>
      <v-toolbar color="primary" dark flat dense>
        <v-toolbar-title>{{ $t("reports.cropProgression.guideTitle") }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <!-- Steps 1-3 -->
        <div v-if="step < 3">
          <v-img
            :src="`/assets/ai-report-guide/crop-progression/step-${step + 1}.png`"
            class="mb-4"
            style="width: 100%"
            contain
          />
          <div class="grey--text mb-1">
            {{ $t("reports.cropProgression.guideStep", { current: step + 1, total: 3 }) }}
          </div>
          <h3 class="primary--text mb-3">{{ $t(`reports.cropProgression.guideStep${step + 1}Title`) }}</h3>
          <p class="body-2 pre-line black--text">{{ $t(`reports.cropProgression.guideStep${step + 1}Body`) }}</p>
        </div>

        <!-- Final tip screen -->
        <div v-else>
          <h3 class="black--text mb-2">{{ $t("reports.cropProgression.guideTip") }}</h3>
          <p class="body-2 black--text">{{ $t("reports.cropProgression.guideTipBody") }}</p>
          <h4 class="grey--text text--darken-1 mt-4 mb-2">
            {{ $t("reports.cropProgression.additionalReportTypes") }}
          </h4>
          <div v-for="idx in indices" :key="idx" class="body-2 black--text">
            {{ $t(`reports.cropProgression.index${idx}`) }}
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pb-4 px-4">
        <v-spacer />
        <v-btn v-if="step > 0" outlined color="primary" @click="step -= 1">
          {{ $t("reports.cropProgression.back") }}
        </v-btn>
        <v-btn outlined color="primary" @click="close">{{ $t("reports.cropProgression.close") }}</v-btn>
        <v-btn v-if="step < 3" color="primary" depressed @click="step += 1">
          {{ $t("reports.cropProgression.next") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GuideDialog",
  props: {
    value: { type: Boolean, default: false },
    metadata: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      step: 0,
      indices: ["NDVI", "MSAVI", "LSWI", "RECI", "NDRE"],
    };
  },
  watch: {
    value(open) {
      if (open) this.step = 0;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.pre-line {
  white-space: pre-line;
}
</style>
